import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import queryString from 'query-string';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import _ from 'lodash';
import { Text } from 'recharts';
import Header from '../../components/Header';
import PublicHeader from '../../components/PublicHeader';
import GochiKidMenuTableShop from '../organisms/GochiKidMenuTableShop';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import {
  getGochiKidMenus,
  getOrderGochiMenus,
  downloadMenu,
  getMenuSetting,
  updateMenuSetting
} from '../../actions/GochiMenus';
import { getAccounts } from '../../actions/Accounts';
import { getShops } from '../../actions/Shop';
import MenuBox from '../../components/MenuBox';
import TabPanelDetail from '../../components/atoms/TabPanelDetail';
import {
  getGochiChildFoodLists,
  getChildFoodShops,
  getChildFoodGroups
} from '../../actions/GochiChildFoodLists';
import {
  getMenuGenreOption,
  getMenuSituationOption,
  getMenuUserTargetOption
} from '../../actions/Options';

const styles = theme => ({
  '@global': {
    body: {
      backgroundColor: '#F7F7F7'
    }
  },
  root: {
    // backgroundColor: '#F7F7F7',
    flexGrow: 1,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 375,
      margin: '0 auto'
    }
  },
  pageTitileDiv: {
    textAlign: 'left',
    marginBottom: 10,
    paddingLeft: 15,
    paddingRight: 15,
    marginTop: 15
  },
  pageDiscriptionDiv: {
    paddingLeft: 26,
    paddingTop: 2,
    textAlign: 'left'
  },
  mainPaper: {
    position: 'relative',
    margin: 0,
    padding: 0
  },
  mainContent: {
    padding: '20px 15px',
    margin: '-15px -10px'
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  buttonGroupLeft: {
    textAlign: 'left',
    float: 'left'
  },
  buttonRight: {
    textAlign: 'right'
  },
  buttonGroupCenter: {
    textAlign: 'center',
    padding: '15px 20px'
  },
  textInput100: {
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  // mainModal: {
  //   zIndex: '99999!important'
  // },
  fs24: {
    fontSize: '24px',
    fontWeight: 700
  },
  textCenter: {
    textAlign: 'center',
    padding: 15
  },
  tabpanelHeader: {
    padding: '0 10px',
    borderBottom: '2px solid #D8EBFF',
    minHeight: 'unset'
  },
  btnTabpanel: {
    padding: '5px 10px',
    backgroundColor: '#ffffff',
    borderRadius: '3px 3px 0 0',
    fontSize: 14,
    fontWeight: 600,
    color: '#777777',
    height: 'auto',
    minHeight: 'unset',
    borderTop: '5px solid #F7F7F7',
    width: '50%',
    cursor: 'pointer',

    '&:first-child': {
      marginRight: 2
    },
    '&:last-child': {
      marginLeft: 2
    }
  },
  tabSelected: {
    backgroundColor: '#D8EBFF',
    fontWeight: 'bold',
    color: '#000000 !important',
    borderTopColor: '#D8EBFF'
  },
  modalMobile: {
    maxWidth: 380,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  btnBack: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 20,
    paddingBottom: 20
  },
  showHideGochiPrice: {
    paddingLeft: 25,
    display: 'flex',
    justifyContent: 'flex-start'
  },
  textSwitch: {
    paddingRight: 10
  },
  font14: {
    fontSize: 14
  },
  bold: {
    fontWeight: 'bold'
  },
  buttonSetting: {
    padding: '6px 0px'
  },
  btnHelp: {
    padding: 0,
    minWidth: 0
  },
  settingIcon: {
    fontSize: 18
  },
  textSubTitle: {
    textAlign: 'center',
    fontSize: 20,
    fontWeight: 700,
    borderBottom: 0,
    paddingTop: 40,
    paddingBottom: 10
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      identityStatuses: state.identities.statuses,
      showHides: state.gochiMenus.showHide,
      menuSetting: state.gochiMenus.setting,
      menuGenre: state.options.listMenuGenre,
      menuSituation: state.options.listMenuSituation,
      menuUserTarget: state.options.listMenuUserTarget
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiKidMenus,
          getOrderGochiMenus,
          downloadMenu,
          getAccounts,
          getShops,
          getGochiChildFoodLists,
          getChildFoodShops,
          getChildFoodGroups,
          getMenuSetting,
          updateMenuSetting,
          getMenuGenreOption,
          getMenuSituationOption,
          getMenuUserTargetOption
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openAdd', 'updateOpenAdd', false),
  withState('openAddConfirm', 'updateOpenAddConfirm', false),
  withState('openViewOrderCustom', 'updateOpenViewOrderCustom', false),
  withState('openViewOrderCustomList', 'updateOpenViewOrderCustomList', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('shopId', 'setShopId', null),
  withState('orderMenuShopId', 'setOrderMenuShopId', null),
  withState('groupName', 'setGroupName', ''),
  withState('shopName', 'setShopName', ''),
  withState('menuName', 'setMenuName', ''),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 10),
  withState('identityStatus', 'setIdentityStatus', ''),
  withState('showHide', 'setShowHide', ''),
  withState('hasMore', 'setHasMore', true),
  withState('nextHref', 'setNextHref', 1),
  withState('listMenus', 'setListMenus', []),
  withState('valueTab', 'setValueTab', 0),
  withState('hasMoreChildFood', 'setHasMoreChildFood', true),
  withState('nextHrefChildFood', 'setNextHrefChildFood', 1),
  withState('groupId', 'setGroupId', null),
  withState('showGochiPrice', 'setShowGochiPrice', true),
  withState('openMenuSettingModal', 'setOpenMenuSettingModal', false),
  withState('openMenuHelpModal', 'setOpenMenuHelpModal', false),
  withState('menuGenre', 'setMenuGenre', []),
  withState('menuSituation', 'setMenuSituation', []),
  withState('menuUserTarget', 'setMenuUserTarget', []),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangePage: props => (event, page, limit) => {
      setTimeout(() => {
        // if (page === props.nextHref) {

        // }
        const searchKey = {
          gochiKidFlag: 0,
          page,
          limit
        };

        props.updateLoading(true);
        props.updateOpenProgress(true);
        props.actions
          .getGochiKidMenus(searchKey)
          .then(data => {
            // props.checkSession(data);
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);
            props.updateOpenTable(true);
            let list = [];
            if (page > 1) {
              list = props.listMenus;
            } else {
              list = [];
              props.setNextHref(1);
            }

            if (data.type === 'GET_GOCHI_MENUS_SUCCESS') {
              if (data.payload.menus) {
                data.payload.menus.map(menu => {
                  return list.push(menu);
                });
                props.setListMenus(list);
                if (data.payload.offset + 10 < data.payload.totalCount) {
                  props.setHasMore(true);
                } else {
                  props.setHasMore(false);
                }
              }
            }
          })
          .catch(error => {
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);
            // props.setNextHref(1);
            console.log(error);
          });
      }, 100);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);

        this.props.handleChangePage(null, 1, 10);

        const searchGroupId = queryString.parse(this.props.location.search)
          .groupId;
        this.props.setGroupId(Number(searchGroupId));
        this.props.actions.getChildFoodGroups();
        this.props.actions.getChildFoodShops();
        this.props.actions
          .getMenuSetting(data.payload.shopId)
          .then(menuSettingData => {
            if (menuSettingData.type === 'GET_MENU_SETTING_SUCCESS') {
              this.props.checkSession(menuSettingData);
              this.props.setShowGochiPrice(
                _.get(menuSettingData, 'payload.allowMenuPrice', false) === 1
              );
            }
          });
      });
      this.props.actions.getMenuGenreOption().then(data => {
        this.props.checkSession(data);
        this.props.setMenuGenre(data.payload);
      });
      this.props.actions.getMenuSituationOption().then(data => {
        this.props.checkSession(data);
        this.props.setMenuSituation(data.payload);
      });
      this.props.actions.getMenuUserTargetOption().then(data => {
        this.props.checkSession(data);
        this.props.setMenuUserTarget(data.payload);
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    handleChangePage,
    account,
    openTable,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    groupName,
    shopName,
    menuName,
    resultMessage,
    setResultMessage,
    page,
    hasMore,
    nextHref,
    setNextHref,
    listMenus,
    valueTab,
    handleRedirect,
    menuGenre,
    menuSituation,
    menuUserTarget
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isChildShop =
      typeof account !== 'undefined' &&
      account.role === 'SHOP' &&
      (account.belongToChildGroups !== 'undefined' &&
        account.belongToChildGroups.length > 0);

    const isChildShopOnly =
      typeof account !== 'undefined' &&
      account.role === 'SHOP' &&
      ((account.belongToChildGroups !== 'undefined' &&
        account.belongToChildGroups.length > 0) ||
        account.childShopFlag === 1);
    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const isDeveloper =
      typeof account !== 'undefined' && account.role === 'DEVELOPER';
    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;
    const roles = {
      isShop,
      isGroup,
      isSecretariat,
      isDeveloper,
      isChildShop,
      isChildShopOnly
    };

    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress,
      setResultMessage
    };

    const rowsPerPage = document.getElementById('rowsPerPage');
    let limitNum = 100;
    if (rowsPerPage) {
      limitNum = rowsPerPage.textContent;
    }

    const searchKey = {
      groupName,
      shopName,
      menuName,
      page,
      limit: limitNum
    };

    const loadMoreMenus = async () => {
      setNextHref(nextHref + 1);
      handleChangePage(null, nextHref + 1, 10);
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    const backAction = () => handleRedirect('/release_step');

    return (
      <div className={classes.root}>
        <CssBaseline />
        {isReleased ? <Header /> : <PublicHeader />}
        <div className={classes.pageTitileDiv}>
          <Typography color="textPrimary" className={classes.fs24}>
            こどもごちめし
          </Typography>
        </div>
        <TabPanelDetail value={valueTab} index={0}>
          <div className={classes.mainContent}>
            <Paper className={classes.mainPaper} elevation={3}>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell className={classes.textSubTitle}>
                      メニュー登録
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              {openTable && (
                <GochiKidMenuTableShop
                  searchKey={searchKey}
                  roles={roles}
                  progress={progress}
                  page={page}
                  handleChangePage={handleChangePage}
                  selectedPage={nextHref}
                  listMenus={listMenus}
                  account={account}
                  menuGenre={menuGenre}
                  menuSituation={menuSituation}
                  menuUserTarget={menuUserTarget}
                  addGochiKidButton
                />
              )}
              <ProgressDialog openProgress={openProgress} loading={loading} />
            </Paper>
            {isShop && !isReleased && (
              <div className={classes.btnBack}>
                <Button variant="text" color="primary" onClick={backAction}>
                  <Text className={[classes.bold, classes.font14]}>
                    TOPへ戻る
                  </Text>
                </Button>
              </div>
            )}
            {hasMore && (
              <div className={classes.textCenter}>
                <Button
                  variant="contained"
                  color="primary"
                  // className={classes.buttonSend}
                  onClick={() => {
                    loadMoreMenus();
                  }}
                >
                  もっと見る
                </Button>
              </div>
            )}
          </div>
        </TabPanelDetail>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
        {isReleased && <MenuBox account={account} />}
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
